{
  "app.name": "BRES",
  "common.save": "Save",
  "common.saving": "Saving",
  "common.saved": "Saved",
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.back": "Back",
  "common.edit": "Edit",
  "common.delete": "Delete",
  "common.remove": "Remove",
  "common.add": "Add",
  "common.create": "Create",
  "common.search": "Search",
  "common.clear_search": "Clear search",
  "common.filter": "Filter",
  "common.all": "All",
  "common.none": "None",
  "common.optional": "(optional)",
  "common.yes": "Yes",
  "common.no": "No",
  "common.retry": "Try again",
  "common.loading": "Loading",
  "common.more": "More",
  "common.actions": "Actions",
  "common.open": "Open",
  "common.copy": "Copy",
  "common.copied": "Copied",
  "common.view": "View",
  "common.download": "Download",
  "common.select_all": "Select all",
  "common.selected": "{count, plural, one {# selected} other {# selected}}",
  "common.clear_selection": "Clear selection",
  "common.results": "{count, plural, =0 {No results} one {# result} other {# results}}",
  "common.load_more": "Load more",
  "common.unknown": "Unknown",
  "common.never": "Never",
  "common.today": "Today",
  "common.by": "by {name}",
  "common.version": "Version {version}",
  "common.required": "Fill in this field",
  "common.notes": "Notes",
  "error.title": "That did not work",
  "error.network": "No connection to the server. Your changes are still on screen; try again.",
  "error.forbidden": "You do not have permission for this in this organisation.",
  "error.not_found": "This does not exist (any more) or belongs to another organisation.",
  "error.validation": "Check the highlighted fields.",
  "error.conflict": "Someone else changed this in the meantime.",
  "error.rate_limited": "Too many requests in a row. Try again in a minute.",
  "error.server": "Something went wrong on our side. Try again.",
  "error.reference": "Reference for support: {id}",
  "error.page_title": "This page could not load",
  "error.code.version_conflict": "Someone else changed this in the meantime. Refresh to see the latest version.",
  "error.code.localization.test_output": "This is test output from the AI test adapter, not a real translation. It cannot be approved.",
  "error.code.localization.publish_incomplete": "You can publish once the title and description of every website listing in that language are approved.",
  "error.code.localization.base_mismatch": "The version you built on does not belong to this text and language. Load the current version again.",
  "error.code.localization.source_changed": "The source text changed after this proposal. Make a new proposal.",
  "error.code.localization.qa_critical": "The fact check found a critical mismatch. It cannot be approved.",
  "error.code.localization.not_reviewable": "This version was already reviewed or replaced.",
  "error.code.localization.use_source_editor": "This is the source language. Edit the source text on the listing itself.",
  "error.code.ai.budget_exceeded": "This month's AI budget is used up. Existing translations keep working.",
  "error.code.ai.unavailable": "AI is not available right now. Translate by hand or try again later.",
  "error.code.ai.unknown_locale": "BRES does not know this language yet.",
  "error.code.ai.unsupported_owner": "Only listing texts can be translated with AI for now.",
  "error.code.ai.refused": "The AI provider refused this request. Translate this text by hand.",
  "error.code.import.source_paused": "This import source is paused.",
  "error.code.import.upload_required": "Upload a file for this source first.",
  "error.code.import.not_awaiting_review": "This import run is no longer waiting for a decision.",
  "error.code.import.source_changed": "The source changed after the review. Run a new dry run.",
  "error.code.import.mass_withdrawal_unconfirmed": "Many listings are missing from the source. Confirm or reject the withdrawals.",
  "error.code.channel.kill_switch": "This portal is stopped by the emergency stop.",
  "error.code.channel.no_feed_adapter": "There is no feed connection for this portal yet.",
  "error.code.channel.no_publication": "There is no published version to export yet.",
  "error.code.channel.status_requires_evidence": "Accepted or live needs evidence from the portal itself.",
  "error.code.media.order_mismatch": "The order does not contain exactly all images of this listing. Refresh and try again.",
  "error.code.media.cover_must_be_photo": "Only a photo can be the cover image.",
  "error.code.restore.no_active_offer": "That version had no active offer.",
  "error.code.publication.no_locales": "This website has no published language yet.",
  "error.code.build.generation_mismatch": "The build belongs to a different publication. Refresh and try again.",
  "error.code.build.release_missing": "The build succeeded but the release is missing.",
  "nav.label": "Main navigation",
  "nav.group_today": "Today",
  "nav.group_clients": "Clients",
  "nav.group_listings": "Listings",
  "nav.group_distribution": "Publishing",
  "nav.group_system": "System",
  "nav.overview": "Overview",
  "nav.leads": "Enquiries",
  "nav.contacts": "Contacts",
  "nav.tasks": "Tasks",
  "nav.properties": "Properties",
  "nav.localization": "Languages",
  "nav.website": "Website",
  "nav.channels": "Portals",
  "nav.imports": "Imports",
  "nav.ai": "AI assistant",
  "nav.settings": "Settings",
  "nav.open_menu": "Open menu",
  "nav.breadcrumbs": "Breadcrumbs",
  "shell.search": "Search or jump to…",
  "shell.search_label": "Search and navigate",
  "shell.command_placeholder": "Find a property, screen or action",
  "shell.command_empty": "Nothing found. Try a reference such as TB-4127.",
  "shell.command_group_pages": "Screens",
  "shell.command_group_properties": "Properties",
  "shell.command_group_actions": "Actions",
  "shell.command_hint_open": "open",
  "shell.command_hint_move": "choose",
  "shell.command_hint_close": "close",
  "shell.action_new_property": "New property",
  "shell.action_publish": "Publish website",
  "shell.action_theme": "Switch light or dark",
  "shell.switch_org": "Switch organisation",
  "shell.org_label": "Organisation",
  "shell.demo": "Demo",
  "shell.demo_hint": "Fictional data; messages go to a local test mailbox.",
  "shell.user_menu": "Account menu",
  "shell.language": "Admin language",
  "shell.theme": "Appearance",
  "shell.theme_system": "Match system",
  "shell.theme_light": "Light",
  "shell.theme_dark": "Dark",
  "shell.sign_out": "Sign out",
  "shell.signed_out": "You are signed out",
  "shell.toasts": "Notifications",
  "shell.support_access": "Temporary support access until {date}",
  "shell.no_membership_title": "No access yet",
  "shell.no_membership_body": "Your account is not linked to an organisation yet. Ask an administrator to invite you.",
  "login.title": "Sign in to BRES",
  "login.email": "Email address",
  "login.password": "Password",
  "login.submit": "Sign in",
  "login.failed": "Email address or password is incorrect.",
  "login.totp_title": "Confirm with your authenticator app",
  "login.totp_code": "6-digit code",
  "login.totp_submit": "Confirm",
  "login.totp_failed": "This code is incorrect or has expired.",
  "login.demo": "Local demo: the logins are in var/demo-accounts.txt.",
  "role.owner": "Owner",
  "role.admin": "Administrator",
  "role.agent": "Agent",
  "role.editor": "Editor",
  "role.reviewer": "Language reviewer",
  "role.viewer": "Viewer",
  "kind.apartment": "Apartment",
  "kind.penthouse": "Penthouse",
  "kind.duplex": "Duplex",
  "kind.studio": "Studio",
  "kind.townhouse": "Townhouse",
  "kind.semi_detached": "Semi-detached house",
  "kind.detached_house": "Detached house",
  "kind.villa": "Villa",
  "kind.bungalow": "Bungalow",
  "kind.finca": "Finca",
  "kind.country_house": "Country house",
  "kind.cave_house": "Cave house",
  "kind.plot": "Building plot",
  "kind.commercial": "Commercial property",
  "kind.garage": "Garage",
  "kind.other": "Other",
  "offer.sale": "For sale",
  "offer.long_let": "For rent",
  "offer.holiday_let": "Holiday rental",
  "status.available": "Available",
  "status.reserved": "Reserved",
  "status.sold": "Sold",
  "status.let": "Let",
  "status.withdrawn": "Withdrawn",
  "editorial.draft": "Draft",
  "editorial.ready": "Ready",
  "editorial.archived": "Archived",
  "lead.status.new": "New",
  "lead.status.contacted": "Contacted",
  "lead.status.qualified": "Qualified",
  "lead.status.viewing": "Viewing",
  "lead.status.offer": "Offer",
  "lead.status.won": "Won",
  "lead.status.lost": "Lost",
  "lead.status.spam": "Spam",
  "lead.kind.property_enquiry": "Property question",
  "lead.kind.general": "General question",
  "lead.kind.viewing_request": "Viewing request",
  "lead.kind.seller_intake": "Seller",
  "lead.kind.shortlist_reply": "Reply to selection",
  "build.status.queued": "Queued",
  "build.status.running": "Running",
  "build.status.succeeded": "Succeeded",
  "build.status.promoted": "Live",
  "build.status.failed": "Failed",
  "build.status.checks_failed": "Checks failed",
  "build.status.superseded": "Superseded",
  "build.status.cancelled": "Cancelled",
  "channel.production": "Production",
  "channel.preview": "Preview",
  "priority.low": "Low",
  "priority.normal": "Normal",
  "priority.high": "High",
  "priority.urgent": "Urgent",
  "audit.task.updated": "Task updated",
  "audit.task.created": "Task created",
  "audit.site.rolled_back": "Website rolled back",
  "audit.site.promoted": "New version live",
  "audit.site.emergency_withdrawal": "Property removed from the website immediately",
  "audit.site.build_superseded": "Build superseded by a newer one",
  "audit.site.build_failed": "Website build failed",
  "audit.shortlist.shared": "Selection shared",
  "audit.shortlist.share_revoked": "Share link revoked",
  "audit.shortlist.created": "Selection created",
  "audit.rights.revoked": "Right revoked",
  "audit.rights.granted": "Right recorded",
  "audit.publication.created": "Publication started",
  "audit.property.updated": "Property updated",
  "audit.property.duplicated": "Property duplicated",
  "audit.property.created": "Property created",
  "audit.note.added": "Note added",
  "audit.media.rights_updated": "Image rights updated",
  "audit.media.reordered": "Photos reordered",
  "audit.media.removed": "Image removed",
  "audit.media.cover_set": "Cover photo chosen",
  "audit.media.added": "Image added",
  "audit.localization.proposed": "Translation proposed",
  "audit.localization.approve": "Translation approved",
  "audit.localization.reject": "Translation rejected",
  "audit.localization.request_changes": "Changes requested on translation",
  "audit.localization.term_saved": "Term saved",
  "audit.localization.term_deleted": "Term deleted",
  "audit.locale.profile_saved": "Language profile saved",
  "audit.site.locales_saved": "Website languages saved",
  "audit.appointment.created": "Appointment created",
  "audit.contact.updated": "Contact updated",
  "audit.import.source_created": "Import source added",
  "audit.ai.budget_set": "AI budget set",
  "audit.team.member_updated": "Team member changed",
  "audit.lead.received": "Enquiry received",
  "audit.lead.updated": "Enquiry updated",
  "audit.import.started": "Import started",
  "audit.import.rejected": "Import rejected",
  "audit.import.failed": "Import failed",
  "audit.import.diffed": "Import differences ready",
  "audit.import.applied": "Import applied",
  "audit.field.unlocked": "Field unlocked",
  "audit.field.locked": "Field locked",
  "audit.contact.created": "Contact created",
  "audit.channel.updated": "Portal setting changed",
  "audit.channel.feed_generated": "Portal feed generated",
  "audit.brief.created": "Search profile recorded",
  "audit.ai.localize": "AI translation requested",
  "audit.ai.eval_case": "AI evaluation completed",
  "actor.system": "System",
  "actor.platform": "BRES platform",
  "actor.build": "Website build",
  "actor.website": "Website",
  "actor.import": "Import",
  "actor.unknown": "Unknown",
  "feature.private_pool": "Private pool",
  "feature.communal_pool": "Communal pool",
  "feature.garden": "Garden",
  "feature.terrace": "Terrace",
  "feature.balcony": "Balcony",
  "feature.roof_terrace": "Roof terrace",
  "feature.garage": "Garage",
  "feature.parking": "Parking",
  "feature.storage_room": "Storage room",
  "feature.lift": "Lift",
  "feature.air_conditioning": "Air conditioning",
  "feature.heating": "Heating",
  "feature.solar_panels": "Solar panels",
  "feature.fireplace": "Fireplace",
  "feature.fitted_kitchen": "Fitted kitchen",
  "feature.furnished": "Furnished",
  "feature.barbecue": "Barbecue",
  "feature.gated_community": "Gated community",
  "feature.sea_front": "Seafront",
  "feature.near_beach": "Near the beach",
  "feature.near_golf": "Near golf",
  "feature.wheelchair_accessible": "Wheelchair accessible",
  "feature.fibre_internet": "Fibre internet",
  "feature.water_deposit": "Water deposit",
  "feature.guest_apartment": "Guest apartment",
  "feature.tourist_license": "Tourist licence",
  "view.sea": "Sea view",
  "view.mountain": "Mountain view",
  "view.teide": "View of Teide",
  "view.golf": "Golf view",
  "view.pool": "Pool view",
  "view.garden": "Garden view",
  "view.city": "City view",
  "view.countryside": "Countryside view",
  "orientation.n": "North",
  "orientation.ne": "North-east",
  "orientation.e": "East",
  "orientation.se": "South-east",
  "orientation.s": "South",
  "orientation.sw": "South-west",
  "orientation.w": "West",
  "orientation.nw": "North-west",
  "energy.status.certified": "Certified",
  "energy.status.in_progress": "Certificate in progress",
  "energy.status.exempt": "Exempt",
  "energy.status.unknown": "Unknown",
  "precision.street": "Street",
  "precision.area": "Area",
  "precision.municipality": "Municipality",
  "precision.hidden": "Hidden",
  "ownership.own": "Own listing",
  "ownership.partner": "Partner listing",
  "ownership.development": "New development",
  "rights.source.own_photography": "Own photography",
  "rights.source.owner_supplied": "Supplied by owner",
  "rights.source.stock_license": "Stock licence",
  "rights.source.partner_feed": "Partner feed",
  "rights.source.generated": "Generated image",
  "rights.source.unknown": "Unknown",
  "rights.scope.website": "Website",
  "rights.scope.portal": "Portals",
  "rights.scope.network": "Network",
  "rights.basis.mandate": "Mandate",
  "rights.basis.owner_consent": "Owner consent",
  "rights.basis.source_license": "Source licence",
  "rights.basis.partner_agreement": "Partner agreement",
  "period.month": "per month",
  "period.week": "per week",
  "period.night": "per night",
  "shell.density": "Density",
  "shell.density_comfortable": "Comfortable",
  "shell.density_compact": "Compact",
  "shell.theme_switch": "Choose appearance",
  "shell.shortcuts": "Keyboard shortcuts",
  "shell.shortcuts_lead": "Work everywhere except in input fields.",
  "shell.shortcut_search": "Search or jump to",
  "shell.shortcut_help": "This overview",
  "shell.shortcut_go": "Go to {page}",
  "shell.shortcut_then": "then",
  "shell.loading": "Loading",
  "login.lead": "Use the email address of your work account.",
  "login.art_title": "Your agency, from listing to website.",
  "login.art_lead": "Manage homes, follow up enquiries, translate texts and publish to your site and portals.",
  "shell.command_group_recent": "Recently opened",
  "nav.group_platform": "Platform",
  "nav.platform_dashboard": "Dashboard",
  "nav.platform_sites": "Sites and SEO",
  "shell.platform_name": "BRES platform",
  "shell.platform_role": "Platform administration",
  "shell.platform_label": "Platform",
  "shell.clients_label": "Clients",
  "shell.support_until": "access until {date}",
  "shell.command_group_platform": "Platform",
  "nav.blog": "Blog",
  "nav.chat": "Chatbot",
  "nav.group_bres_site": "BRES website",
  "nav.platform_ai": "AI options",
  "nav.platform_bres_blog": "Blog",
  "nav.platform_bres_chat": "Chatbot",
  "common.clear": "Clear",
  "error.code.ai.not_in_plan": "This AI feature is not in the plan of this organisation or site.",
  "error.code.blog.checks_blocking": "First resolve the blocking items in the checks.",
  "error.code.blog.test_output": "The text still contains test adapter output. Rewrite it before you approve.",
  "error.code.blog.locale_locked": "This language version is in review or approved. Request changes first.",
  "error.code.blog.archived": "This article is archived.",
  "error.code.blog.not_draft": "Only a draft can be submitted for review.",
  "error.code.blog.not_in_review": "This language version is not in review.",
  "error.code.blog.locale_published": "This language version is already published and cannot be removed from the brief.",
  "error.code.blog.slug_taken": "No free slug was found.",
  "error.code.chat.unavailable": "The chatbot is not available on this site.",
  "audit.ai.entitlement_changed": "AI feature changed by BRES",
  "audit.ai.cap_changed": "AI cap changed by BRES",
  "audit.ai.feature_requested": "Interest in AI feature registered",
  "audit.blog.brief_created": "Blog brief created",
  "audit.blog.brief_updated": "Blog brief updated",
  "audit.blog.archived": "Article archived",
  "audit.blog.ai_draft": "AI draft created",
  "audit.blog.edited": "Article edited",
  "audit.blog.approval_cleared": "Approval cleared by a change",
  "audit.blog.submitted": "Submitted for review",
  "audit.blog.approved": "Language version approved",
  "audit.blog.request_changes": "Changes requested",
  "audit.blog.reject": "Language version rejected",
  "audit.blog.source_created": "Source added",
  "audit.blog.source_updated": "Source updated",
  "audit.blog.category_saved": "Blog category saved",
  "audit.chat.settings_saved": "Chatbot settings saved",
  "audit.chat.handoff": "Chat conversation turned into an enquiry",
  "audit.chat.knowledge_created": "Chat knowledge added",
  "audit.chat.knowledge_updated": "Chat knowledge updated",
  "audit.chat.knowledge_deleted": "Chat knowledge deleted",
  "audit.chat.purged": "Chat conversations cleaned up after the retention period"
}
